import { MabraStandaloneParagraph } from '@/mabra/components/Paragraph';
import { LabradorComponent } from '@/types/component';
import parseStyle from '@/utils/parseStyle';
import withDebugMetadata from '@/utils/withDebugMetadata';
import { isString } from 'typesafe-utils';

export const MabraLabradorParagraph: LabradorComponent = ({ type, data, meta }) => {
  const metaStyle = meta?.attributes?.style;
  if (metaStyle && isString(metaStyle)) {
    meta.attributes.style = parseStyle(metaStyle);
  }

  return (
    <MabraStandaloneParagraph
      content={data.content}
      attributes={meta.attributes}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default MabraLabradorParagraph;
